import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class StringValidators {
  static noSpecialCharacters(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      if (/[^a-zA-Z0-9\-]/.test(control.value)) {
        return { noSpecialCharacters: true }
      }

      return null;
    };
  }
}
